//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Aldrete',
  data () {
    return {
      form: {
        limb: '',
        breath: '',
        loop: '',
        state: '',
        bloodOxygen: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '2', name: '可按指令或自主活动四个肢体'},
        {value: '1', name: '可按指令或自主活动两个肢体'},
        {value: '0', name: '无法活动肢体'}
      ],
      dataList2: [
        {value: '2', name: '可深呼吸或随意咳嗽'},
        {value: '1', name: '存在呼吸窘迫或受限'},
        {value: '0', name: '存在呼吸暂停'}
      ],
      dataList3: [
        {value: '2', name: '血压波动不超过麻醉前20%'},
        {value: '1', name: '血压波动为麻醉前20%-49%'},
        {value: '0', name: '血压波动超过麻醉前50%'}
      ],
      dataList4: [
        {value: '2', name: '完全清醒'},
        {value: '1', name: '可被唤醒'},
        {value: '0', name: '对刺激无反应'}
      ],
      dataList5: [
        {value: '2', name: '呼吸室内空气，可维持＞92%'},
        {value: '1', name: '辅助给氧，可维持＞90%'},
        {value: '0', name: '辅助给氧仍＜90%'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        console.log('tc发版无意义')
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Aldrete.vue